export const GuideSectionTypes = {
  JS: 'JS',
  HTML: 'HTML',
};
